import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const TopBar = () => {
  const session = useSelector((state) => state.sessionAuth);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const isAuthenticated = Boolean(
    session?.isAuthenticated && session?.token && session.token !== 'expired'
  );
  const archivesPath = isAuthenticated ? '/apps/in/archives' : '/login';
  const searchPath = isAuthenticated ? '/apps/in/archives/search' : '/login';

  const handleSearch = (event) => {
    event.preventDefault();
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    const query = searchValue.trim();
    navigate(query ? `${searchPath}?q=${encodeURIComponent(query)}&auto=1` : searchPath);
  };

  return (
    <section className="home-utility" aria-label="Guide et recherche d’archives">
      <div className="container">
        <div className="home-utility-links">
          <Link to="/guide-utilisateur" className="home-utility-link">
            <span className="home-utility-icon" aria-hidden="true"><i className="ri-menu-unfold-line" /></span>
            <span>Guide utilisateur</span>
          </Link>
          <Link to={archivesPath} className="home-utility-link">
            <span className="home-utility-icon" aria-hidden="true"><i className="ri-function-line" /></span>
            <span>Accès aux archives</span>
          </Link>
        </div>
        <form className="home-search" role="search" onSubmit={handleSearch}>
          <Link className="home-search-options" to={searchPath} title="Ouvrir les options de recherche">
            Options
          </Link>
          <input
            type="search"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            aria-label="Rechercher dans les archives"
            placeholder="Rechercher dans les archives"
          />
          <button type="submit" className="home-search-submit" aria-label="Lancer la recherche">
            <i className="ri-search-2-line" aria-hidden="true" />
          </button>
        </form>
      </div>
    </section>
  );
};

export default TopBar;
